import { UI } from 'common';
import React from 'react';
import Utils from './Utils';

const { WrappedDropdownWithLabel, WrappedInputNumberWithLabel } = UI;
const dropdownOption = [
	{
		label: 'No Change',
		value: '',
	},
	{
		label: 'Allowed',
		value: 'allowed',
	},
	{
		label: 'Not Allowed',
		value: 'not_allowed',
	},
];
const optionCostCodes = [
	{
		label: 'No Change',
		value: '',
	},
	{
		label: 'Yes',
		value: 'Yes',
	},
	{
		label: 'No',
		value: 'No',
	},
];
const optionPerPrint = [
	{
		label: 'No Change',
		value: '',
	},
	{
		label: 'No Limit',
		value: 'no_limit',
	},
	{
		label: 'Limit to...',
		value: 'limit_to',
	},
];

const userFormDropdownProperties = [
	{
		label: 'Role:',
		propertyName: 'role',
	},
	{
		label: 'Add Funds:',
		propertyName: 'addFunds',
	},
	{
		label: 'View Reports:',
		propertyName: 'viewReports',
	},
	{
		label: 'Buy Supplies:',
		propertyName: 'buySupplies',
	},
	{
		label: 'Cost Codes Required:',
		propertyName: 'costCodesRequired',
	},
	{
		label: 'Edit Cost Codes:',
		propertyName: 'editCostCodes',
	},
];

const MultiUsersEditView = ({
	handleFormInputChange,
	errorMessage,
	multiUserState,
	roles,
	disableAllField,
}) => {
	const handleInputChange = e => {
		handleFormInputChange(e.target.name, e.target.value);
	};

	const getOptionsByField = fieldName => {
		if (fieldName === 'role') return roles;
		if (fieldName === 'costCodesRequired') return optionCostCodes;
		return dropdownOption;
	};

	return (
		<div className="account-users-multi-users-edit">
			<div className="p-grid">
				{userFormDropdownProperties.map(({ propertyName, label }) => (
					<WrappedDropdownWithLabel
						className="p-col-12"
						key={propertyName}
						label={label}
						uiElementConfig={{
							name: propertyName,
							value: multiUserState[propertyName],
							options: getOptionsByField(propertyName),
							optionLabel: 'label',
							optionValue: 'value',
							dataqa: propertyName,
							onChange: handleInputChange,
							disabled: disableAllField,
						}}
						errorMessage={
							errorMessage[propertyName] && errorMessage[propertyName][0]
						}
						isInputInvalid={errorMessage[propertyName]}
					/>
				))}
				<WrappedDropdownWithLabel
					className="per-print-limit p-col-12"
					label="Per-Print Limit:"
					uiElementConfig={{
						name: 'perPrint',
						value: multiUserState.perPrint,
						options: optionPerPrint,
						optionLabel: 'label',
						optionValue: 'value',
						dataqa: 'per-print-limit-dropdown',
						onChange: handleInputChange,
						disabled: disableAllField,
					}}
				/>
				<WrappedInputNumberWithLabel
					className="p-col-12"
					label="Per-Print Maximum of:"
					uiElementConfig={{
						value: multiUserState.perPrintValue,
						name: 'perPrintValue',
						dataqa: 'per-print-limit-input',
						disabled: multiUserState.perPrint !== 'limit_to' || disableAllField,
						onChange: handleInputChange,
						mode: 'currency',
						currency: 'USD',
						locale: 'en-US',
						step: 1,
						min: 0,
						max: Utils.MAXIMUM_LIMIT_AMOUNT,
						minFractionDigits: 2,
						maxFracionDigits: 2,
						showButtons: true,
					}}
					errorMessage={
						errorMessage &&
						(errorMessage.perPrintValue ? errorMessage.perPrintValue[0] : '')
					}
					isInputInvalid={
						multiUserState.perPrint === 'limit_to' &&
						multiUserState.perPrint &&
						errorMessage.perPrintValue
					}
				/>
			</div>
		</div>
	);
};
export default MultiUsersEditView;
